"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID_TYPE_DONT_HAVE_FIELD_NAME = exports.ID_TYPE_DONT_HAVE_FIELD_NAME_MAPPING = void 0;
exports.getDontHaveFieldName = getDontHaveFieldName;
var entities_1 = require("@common/entities");
exports.ID_TYPE_DONT_HAVE_FIELD_NAME_MAPPING = (_a = {},
    _a[entities_1.IDTypes.SocialSecurityNumber] = 'dont_have_social_security_number',
    _a[entities_1.IDTypes.DriversLicense] = 'dont_have_drivers_license',
    _a[entities_1.IDTypes.GovernmentIssuedPhotoId] = 'dont_have_government_issued_picture_id',
    _a[entities_1.IDTypes.MilitaryId] = 'dont_have_military_id',
    _a[entities_1.IDTypes.Passport] = 'dont_have_passport',
    _a[entities_1.IDTypes.StudentIdentificationNumber] = 'dont_have_student_identification_number',
    _a[entities_1.IDTypes.Visa] = 'dont_have_visa',
    _a);
exports.ID_TYPE_DONT_HAVE_FIELD_NAME = new Set(Object.values(exports.ID_TYPE_DONT_HAVE_FIELD_NAME_MAPPING));
function getDontHaveFieldName(idType) {
    var normalized = idType.toLowerCase().replace(/[^a-z0-9]+/g, '_');
    return "dont_have_".concat(normalized);
}
